const actions = {
  SET_STATE: 'wallet/SET_STATE',
  FETCH_WALLET_LEDGER: 'wallet/FETCH_WALLET_LEDGER',
  FETCH_LEDGER_SUMMARY: 'wallet/FETCH_LEDGER_SUMMARY',
}

export default actions
